import React from 'react'
import * as Styled from '../HabitatDimensions.styles'

const Dimension = ({ label, value }) => {
  return (
    <Styled.Dimension>
      <div>{label}:</div>
      <div>{value}</div>
    </Styled.Dimension>
  )
}

export default Dimension
